import axios from 'axios';
import { Token } from '../auth/Token';


const axiosClient = () => {
  const { getToken } = Token();
  return axios.create({
    baseURL: `https://circleui-api.herokuapp.com/api/v1`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`
    }
  })
}


export const apiPostCommunity = (data) => {
  return axiosClient().post(`/community`, data)
}

export const apiUpdateCommunity = (id, data) => {
  // let client = axiosClient()
  // client.interceptors.request.use(request => {
  //   console.log('Starting Request', JSON.stringify(request, null, 2))
  //   return request
  // })
  // client.interceptors.response.use(res => {
  //   console.log('Response: ', JSON.stringify(res, null, 2));
  //   return res;
  // }); // for debugging purpose
  return axiosClient().put(`/community/${id}`, data)
}

export const apiGetCommunityById = (id) => {
  // let client = axiosClient()
  // client.interceptors.request.use(request => {
  //   console.log('Starting Request', JSON.stringify(request, null, 2))
  //   return request
  // })
  // client.interceptors.response.use(res => {
  //   console.log('Response: ', JSON.stringify(res, null, 2));
  //   return res;
  // }); // for debugging purpose
  return axiosClient().get(`/community/${id}`)
}

export const apiGetAllCommunities = (skip, limit) => {
  return axiosClient().get(`/community?skip=${skip}&limit=${limit}`)
}

export const apiSearchCommunities = (name, skip, limit) => {
  return axiosClient().get(`/community/search?name=${name}&skip=${skip}&limit=${limit}`)
}

export const apiGetAllUsers = () => {
  return axiosClient().get(`/users?skip=0&limit=0/`)
}

export const apiUpdateUser = (data) => {
  return axiosClient().put(`/users/me/update`, data)
}
  
export const apiGetCurrentUser = () => {
  return axiosClient().get(`/users/me`)
}

export const apiGetUserByEmail = (email) => {
  return axiosClient().get(`/users/${email}`)
}


export const apiGetPostsByCommunity = (communityId) => {
  return axiosClient().get(`/posts/${communityId}?skip=0&limit=100`)
}

export const apiGetAllComments = () => {
  return axiosClient().get(`/comment`)
}

export const apiGetCommentsByPost = (postId) => {
  return axiosClient().get(`/comment/${postId}/post`)
}

export const apiPostComment = (postId, data) => {
  return axiosClient().post(`/comment/${postId}`, data)
}

export const apiDeleteComment = (commentId) => {
  return axiosClient().delete(`/comment/${commentId}`)
}

export const apiUpdateComment = (commentId, data) => {
  return axiosClient().put(`/comment/${commentId}`, data)
}

export const apiJoinCommunity = (id) => {
  return axiosClient().put(`/community/${id}/join`)
}

export const apiLeaveCommunity = (id) => {
  return axiosClient().put(`/community/${id}/leave`)
}

export const apiCreatePost = data => {
  return axiosClient().post('/post', data);
}

export const apiGetCommunityPosts = (id, skip, limit) => {
  return axiosClient().get(`/posts/${id}/?skip=${skip}&limit=${limit}`);
}

export const apiDeleteSpecificCommunityPost = id => {
  return axiosClient().delete(`/post/${id}`);
}

export const apiGetSpecificCommunityPost = id => {
  return axiosClient().get(`/post/${id}`);
}

export const apiLikeSpecificCommunityPost = (id, data) => {
  return axiosClient().post(`/post/${id}/toggle-like`, data);
}

export const apiUpdateSpecificCommunityPost = (id, data) => {
  return axiosClient().put(`/post/${id}`, data);
}

export const apiApproveRequest = (id, email) => {
  return axiosClient().put(`/community/${id}/manage_member`,
    {
      "email": email,
      "option": "approve"
    }
  )
}

export const apiRejectRequest = (id, email) => {
  return axiosClient().put(`/community/${id}/manage_member`,
    {
      "email": email,
      "option": "reject"
    }
  )
}

export const apiRemoveMember = (id, email) => {
  return axiosClient().put(`/community/${id}/manage_member`,
    {
      "email": email,
      "option": "remove"
    }
  )
}

export const apiAdminDeletePost = (id) => {
  return axiosClient().delete(`/post/${id}/admin-delete`);
}

export const apiCreateAnnouncement = (communityId, data) => {
  return axiosClient().post(`/announcement/${communityId}`, data)
}

export const apiGetAnnouncementsByCommunityId = (communityId) => {
  return axiosClient().get(`/announcement/${communityId}/community`)
}

export const apiUpdateAnnouncement = (id, data) => {
  return axiosClient().put(`/announcement/${id}`, data)
}

export const apiDeleteAnnouncement = (id) => {
  return axiosClient().delete(`/announcement/${id}`)
}

export const apiCreateEvent = (data) => {
  return axiosClient().post(`/event`, data)
}

export const apiGetEventById = (id) => {
  return axiosClient().get(`/event/${id}`)
}

export const apiUpdateEventById = (id, data) => {
  return axiosClient().put(`/event/${id}`, data)
}

export const apiDeleteEventById = (id) => {
  return axiosClient().delete(`/event/${id}`)
}

export const apiBookmarkEvent = (id) => {
  return axiosClient().put(`/event/${id}/bookmark`)
}

export const apiUnbookmarkEvent = (id) => {
  return axiosClient().put(`/event/${id}/unbookmark`)
}

export const apiGetEvents = (skip, limit) => {
  return axiosClient().get(`/events?skip=${skip}&limit=${limit}`)
}

export const apiSearchEvents = (name, skip, limit) => {
  return axiosClient().get(`/events/search?name=${name}&skip=${skip}&limit=${limit}`)
}

export const apiThisMonthEvents = (month, year) => {
  return axiosClient().get(`/this-months-events?current_month=${month}&current_year=${year}`)
}